module.exports = __webpack_public_path__ + "img/Unidad10-2.897c3a9e.png";